<template>
  <v-navigation-drawer
    class="sidebar-nav"
    :value="drawer"
    :clipped="$vuetify.breakpoint.mobile"
    dark
    app
    :stateless="!tourFinished"
    :temporary="$vuetify.breakpoint.mobile"
  >
    <v-img
      :src="require('@/assets/img/bg-drawer.jpg')"
      height="100%"
      gradient="to top right, rgba(0,0,0,0.9), rgba(0,0,0,0.8)"
      style="position: absolute"
    />
    <v-list dense nav>
      <v-list-item
        two-line
        class="px-0"
        @click="$router.push({ name: 'Settings' })"
      >
        <v-list-item-content>
          <v-avatar size="100">
            <img :src="user.get('profilePicture')" />
          </v-avatar>
          <h3 class="text-center py-3">
            {{ user.get("firstName") }} {{ user.get("lastName") }}
          </h3>
        </v-list-item-content>
      </v-list-item>
      <v-divider />

      <template v-for="item in items">
        <v-row v-if="item.heading" :key="item.heading" align="center">
          <v-col cols="6">
            <v-subheader v-if="item.heading">{{ item.heading }}</v-subheader>
          </v-col>
          <v-col cols="6" class="text-center">
            <a href="#!" class="body-2 black--text">EDIT</a>
          </v-col>
        </v-row>

        <v-list-group
          v-else-if="item.children"
          :key="item.text"
          v-model="item.model"
          append-icon
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>{{ item.text }} </v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list-item v-for="(child, i) in item.children" :key="i" link>
            <v-list-item-action v-if="child.icon">
              <v-icon>{{ child.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ child.text }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
        <v-list-item
          v-else-if="item.show === 'web' ? !$vuetify.breakpoint.mobile : true"
          :key="item.text"
          link
          :to="item.path"
          :data-v-tour="item.tour"
        >
          <v-list-item-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ item.text }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
      <v-list-item @click="logout">
        <v-list-item-action>
          <v-icon>mdi-logout</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>Logout</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item >
        <v-list-item-content>
          <img :src="require('@/assets/img/logo-w.png')" alt="" style="max-width:150px; margin:0 auto;" />
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <!-- <template v-slot:append>
      <div class="px-9 pb-3 position-relative">
        <img :src="require('@/assets/img/logo-w.png')" alt="" width="100%" />
      </div>
    </template> -->
  </v-navigation-drawer>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  data () {
    return {
      items:
        localStorage.getItem('userType') === 'student'
          ? [
            {
              icon: 'mdi-home',
              text: 'Home',
              path: '/student-dashboard',
              show: 'web',
              tour: 'Home'
            },
            {
              icon: 'mdi-calendar',
              text: 'Bookings',
              path: '/student-bookings',
              show: 'web',
              tour: 'Bookings'
            },
            {
              icon: 'mdi-chat',
              text: 'Message',
              path: '/chat',
              show: 'web',
              tour: 'Messages'
            },
            {
              icon: 'mdi-bell',
              text: 'Notification',
              path: '/student-notifications',
              show: 'web',
              tour: 'Notifications'
            },
            {
              icon: 'mdi-shield-car',
              text: 'Courses',
              path: '/courses',
              tour: 'Courses'
            },
            {
              icon: 'mdi-certificate',
              text: 'Certificate',
              path: '/certificate',
              tour: 'Certificate'
            },
            {
              icon: 'mdi-credit-card-check',
              text: 'Payments',
              path: '/payments',
              tour: 'Payments'
            },
            {
              icon: 'mdi-cog',
              text: 'Settings',
              path: '/settings',
              tour: 'Settings'
            },
            {
              icon: 'mdi-calendar-week',
              text: 'Availability',
              path: '/availability',
              tour: 'Availability'
            },
            {
              icon: 'mdi-star',
              text: 'Reviews',
              path: '/reviews',
              tour: 'Reviews'
            },
            {
              icon: 'mdi-account-question',
              text: 'Support',
              path: '/support'
            }
          ]
          : [
            {
              icon: 'mdi-calendar',
              text: 'Bookings',
              path: '/dashboard',
              show: 'web',
              tour: 'Bookings'
            },
            {
              icon: 'mdi-calendar-clock',
              text: 'Requested Bookings',
              path: '/request-booking',
              tour: 'Requested Bookings'
            },
            {
              icon: 'mdi-account-group',
              text: 'Students',
              path: '/assigned-students'
            },
            {
              icon: 'mdi-chat',
              text: 'Message',
              path: '/chat',
              show: 'web',
              tour: 'Messages'
            },
            {
              icon: 'mdi-bell',
              text: 'Notification',
              path: '/notifications',
              show: 'web',
              tour: 'Notifications'
            },
            // {
            //   icon: 'mdi-gift',
            //   text: 'Packages',
            //   path: '/packages',
            //   tour: 'Packages'
            // },
            {
              icon: 'mdi-credit-card-check',
              text: 'Payments',
              path: '/payments',
              tour: 'Payments'
            },
            {
              icon: 'mdi-cog',
              text: 'Settings',
              path: '/settings',
              tour: 'Settings'
            },
            {
              icon: 'mdi-star',
              text: 'Reviews',
              path: '/reviews',
              tour: 'Reviews'
            },
            {
              icon: 'mdi-account-question',
              text: 'Support',
              path: '/support'
            }
          ]
    }
  },
  computed: mapGetters(['drawer', 'user', 'tourFinished']),
  methods: mapActions(['logout'])
}
</script>

<style scoped>
.v-list-item.v-list-item--link.theme--dark.active {
  background-color: #2d9a47;
}
.position-relative {
  position: relative;
}
</style>
